import React, { useState } from "react";
import dispositivoAsignadoService from "../../services/dispositivo/dispositivoAsignadoService";
import { IFilterReporteDispositivoAsignado } from "../../Interfaces/DispositivoAsignado/IDispositivoAsignado";

export const useReporteAsignacionDispositivo = (onDismiss) => {
  const [isSend, setIsSend] = useState(false);

  const handlerReporteDispositivosAsignados = (
    filterReport: IFilterReporteDispositivoAsignado
  ) => {
    setIsSend(true);
    dispositivoAsignadoService
      .postReporteDispositivoAsignado(filterReport)
      .then((res) => {
        if (res.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "ReporteAsignacionDispositivos.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          setIsSend(false);
          onDismiss();
        }
      })
      .catch((e: Error) => {
        console.log(e.message);
        setIsSend(false);
        onDismiss();
      });
  };

  return {
    handlerReporteDispositivosAsignados,
    isSend,
  };
};
